// removed by extract-text-webpack-plugin
module.exports = {"Container":"_1zbj8","ContainerActive":"_1YQu4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HotelDetail/HotelFAQ/FAQBar/FAQBar.scss
// module id = 928
// module chunks = 0